import Modal from "../../shared/Modal";
import Button from "../../shared/Button";

const RateExistsModal = ({ visible, setVisible, submit, loading }) => {
  function handleCancelModal() {
    setVisible(false);
  }

  const modalFooter = (
    <>
      <Button onClick={handleCancelModal} type="alternative">
        Cancel
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        onClick={() => submit()}
        type="primary"
      >
        Submit
      </Button>
    </>
  );

  const modalContent = (
    <div className="">
      This rate has already been set, would you like to update it?
    </div>
  );

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      onClose={() => setVisible(false)}
      title="Rate exists"
      footer={modalFooter}
      content={modalContent}
      size="md"
      footerPosition="right"
    />
  );
};

export default RateExistsModal;
